import angular from 'angular'

let LogDetailListController = function (Faq, $mdDialog, $filter, $scope, $state, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;
  $ctrl.id = $state.params.id;

  angular.extend($ctrl, {
    goBack,
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'updated_at'
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }

  function goBack() {
    window.history.back();
  }

  // Local functions

  function loadData() {
    $ctrl.promise = Faq
      .getLogDetails($ctrl.id)
      .then(response => {
        setPlaceHolderValues(response);
        $ctrl.resources = {count: response.length, data: response};
        $ctrl.uiState = response.length ? 'COMPLETE' : 'EMPTY';
        // $ctrl.$scope.$apply();
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
  	_.forEach(arr, item => {
  		if (item.email === null || item.email === undefined) {
  			item.email = $filter('translate')('common-not-informed');
  		}
  	});
  }
}

LogDetailListController.$inject = ['Faq', '$mdDialog', '$filter', '$scope', '$state', 'Toast'];

export default LogDetailListController;



// WEBPACK FOOTER //
// ./client/app/components/faq/log-detail-list.controller.js